// src/context/AuthContext.js
import React, { createContext, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = '';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  // Safely initialize user from localStorage
  const [user, setUser] = useState(() => {
    try {
      const savedUser = localStorage.getItem("user");
      return savedUser ? JSON.parse(savedUser) : null;
    } catch (err) {
      console.warn("Invalid user data in localStorage:", err);
      localStorage.removeItem("user");
      return null;
    }
  });

  const [token, setToken] = useState(() => localStorage.getItem("token") || "");

  const login = async (credentials) => {
    try {

const response = await fetch('/api/admin/login', {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(credentials),
});


      const text = await response.text();
      console.log("Raw response from backend:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Server returned invalid JSON");
      }

      if (!response.ok) {
        throw new Error(data.error || "Login failed");
      }

      // Defensive check
      // Defensive check
if (typeof data !== "object" || !data.token) {
  throw new Error("Invalid backend response format");
}

// Create minimal user object from credentials since backend doesn't return user
const minimalUser = { username: credentials.username };

// Save session
setUser(minimalUser);
setToken(data.token);
localStorage.setItem("user", JSON.stringify(minimalUser));
localStorage.setItem("token", data.token);

console.log("✅ Login success:", minimalUser);  // ✅ Use minimalUser
      navigate("/admin/dashboard");

    } catch (error) {
      console.error("❌ Login failed:", error);
      throw error;
    }
  };

  const logout = () => {
    setUser(null);
    setToken("");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
